import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function Home() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      style={{
        color: '#F3E5AB',
        fontFamily: 'Milonga, serif',
        textAlign: 'left',
        margin: 0,
        padding: 0,
      }}
    >
      {/* Tavern image */}
      <div
        style={{
          marginTop: '-9px',
          position: 'relative',
          width: '100%',
          overflow: 'hidden',
          zIndex: 0,
        }}
      >
        <img
          src="/images/Tavern.png"
          alt="Tavern"
          style={{
            width: '100%',
            height: 'auto',
            display: 'block',
          }}
        />

        {/* Text & Menu */}
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '15%',
            transform: 'translateY(-50%)',
            color: '#F3E5AB',
            textShadow: '2px 2px 4px rgba(0,0,0,0.7)',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            minWidth: '200px',
            zIndex: 2,
          }}
        >
          <div
            style={{
              fontSize: isMobile ? '20px' : '72px',
              textAlign: 'center',
              marginLeft: isMobile ? '-80px' : '-120px',
            }}
          >
            Welcome Travelers
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
            }}
          >
            {/* FEATURED */}
            <Link
              to="/projects/PredictivePolicing?file=All_Crimes.html"
              style={{ textDecoration: 'none', color: '#F3E5AB' }}
              onMouseEnter={() => setHovered('feature')}
              onMouseLeave={() => setHovered(null)}
            >
              <div
                style={{
                  fontSize: isMobile ? '18px' : '50px',
                  cursor: 'pointer',
                  textAlign: 'left',
                }}
              >
                Featured Project
              </div>
            </Link>

            {/* ABOUT */}
            <Link
              to="/About"
              style={{ textDecoration: 'none', color: '#F3E5AB' }}
              onMouseEnter={() => setHovered('about')}
              onMouseLeave={() => setHovered(null)}
            >
              <div
                style={{
                  fontSize: isMobile ? '18px' : '50px',
                  cursor: 'pointer',
                  textAlign: 'left',
                }}
              >
                About Me
              </div>
            </Link>
          </div>
        </div>

        {/* Animated Image */}
        <img
          src={
            hovered === 'feature'
              ? '/images/FeaturedProject.png'
              : hovered === 'about'
              ? '/images/AboutMe.png'
              : ''
          }
          alt=""
          style={{
            position: 'absolute',
            top: '50%',
            right: hovered ? '0%' : '-40%',
            transform: 'translateY(-50%)',
            width: '100%',
            height: 'auto',
            borderRadius: '8px',
            transition: 'right 0.5s ease-in-out',
            pointerEvents: 'none',
            zIndex: 0,
          }}
        />
      </div>

      {/* Bottom Bar */}
      <div style={{ width: '110%', height: '54px', lineHeight: 0, position: 'relative', left: '-5px' }}>
        <img
          src="/images/TopNavigationBar.png"
          alt="Bottom Bar"
          style={{
            width: '100%',
            height: '125%',
            display: 'block',
            margin: 0,
            padding: 0,
          }}
        />
      </div>
    </div>
  );
}
